export const siteInfo = {
  name: '樱花TV',
  slogan: '每一帧，都是极致享受',
  description: '樱花TV致力于为广大影视爱好者提供1080P蓝光超清4K高画质的电影电视剧全集免费在线观看服务。我们采用先进的视频编码与全球CDN加速技术，确保播放流畅不缓冲不卡顿，无论何时何地，都能享受影院级观影体验。片库每日更新，涵盖动作、喜剧、悬疑、爱情、科幻、动画等全品类内容，热门新片与经典老片一应俱全。',
  stats: [
    { label: '每日更新', value: '200+部' },
    { label: '高清片库', value: '50,000+' },
    { label: '流畅播放率', value: '99.9%' },
  ],
  heroImage: 'https://readdy.ai/api/search-image?query=A%20cinematic%20warm-toned%20dark%20theater%20scene%20with%20soft%20cherry%20blossom%20petals%20floating%2C%20luxurious%20velvet%20curtains%20in%20deep%20crimson%2C%20a%20glowing%20large%20screen%20with%20abstract%20film%20projection%20light%2C%20atmospheric%20ambient%20lighting%20with%20warm%20golden%20and%20pink%20accents%2C%20elegant%20and%20artistic%20composition%2C%20high%20detail%2C%20dreamlike%20cinematic%20mood&width=1200&height=800&seq=sakura-hero-01&orientation=landscape',
};

export const topics = [
  { label: '热播新剧', count: '2.3w', tag: 'hot', color: 'primary' },
  { label: '高分电影', count: '1.8w', tag: 'quality', color: 'accent' },
  { label: '国产剧集', count: '3.1w', tag: 'domestic', color: 'secondary' },
  { label: '日韩剧场', count: '1.5w', tag: 'asia', color: 'accent' },
  { label: '欧美大片', count: '2.7w', tag: 'western', color: 'primary' },
  { label: '动漫番剧', count: '4.2w', tag: 'anime', color: 'accent' },
  { label: '纪录片', count: '8.6k', tag: 'doc', color: 'secondary' },
  { label: '综艺娱乐', count: '1.2w', tag: 'variety', color: 'primary' },
  { label: '经典重温', count: '9.3k', tag: 'classic', color: 'accent' },
];

export const updates = [
  { title: '《暗夜追踪》第二季今日上线，4K杜比全景声版本同步更新', time: '2小时前', tag: '新剧上线', badge: 'hot' },
  { title: '《星际穿越》导演剪辑加长版蓝光画质已收录，新增30分钟未公开片段', time: '5小时前', tag: '经典入库', badge: 'new' },
  { title: '暑期档专题「燃夏大片」合集上线，精选50部高燃动作电影', time: '8小时前', tag: '专题更新', badge: 'hot' },
  { title: '播放器升级至v3.2版本，新增智能画质调节与记忆续播功能', time: '1天前', tag: '系统升级', badge: 'info' },
  { title: '《时光之城》大结局1080P+4K双版本同步更新，会员优先观看', time: '1天前', tag: '热剧完结', badge: 'hot' },
  { title: '日漫专区新增《鬼灭之刃》全系列，含剧场版无限列车篇', time: '2天前', tag: '动漫上线', badge: 'new' },
  { title: '服务器节点扩展完成，华东华南地区播放速度提升40%', time: '3天前', tag: '服务优化', badge: 'info' },
  { title: '本周口碑榜更新：《归来之人》登顶，豆瓣评分9.1分力作', time: '3天前', tag: '榜单更新', badge: 'new' },
];

export const comments = [
  { name: '电影猎人', avatar: '影', content: '用了樱花TV半年多了，画质真的没得说，1080P完全不打折扣，比某些收费平台还清晰。最近更新的4K片源也越来越多了，好评！', time: '3天前', likes: 128 },
  { name: '追剧小达人', avatar: '剧', content: '之前一直卡顿烦得要死，换了樱花TV之后才知道什么叫流畅。晚上的高峰期也不缓冲，太感动了，已经推荐给整个宿舍了。', time: '5天前', likes: 96 },
  { name: '深夜观影者', avatar: '夜', content: '片库更新是真的快，新出的剧集当天就能看到高清版。最近迷上了纪录片专区，画质配合大屏投影简直享受，周末宅家必备。', time: '1周前', likes: 203 },
  { name: '技术宅阿明', avatar: '技', content: '作为画质党，4K HDR片源的表现让我惊喜。码率给得很足，暗部细节完全不会糊成一团，给技术团队点个赞。希望动画区4K资源再多一些。', time: '1周前', likes: 87 },
  { name: '家庭影院控', avatar: '家', content: '家里装了投影仪之后一直在找高画质片源，朋友推荐了樱花TV。蓝光原盘级别的画质投到120寸幕布上效果炸裂，关键还免费，太良心了。', time: '2周前', likes: 156 },
];

export const contactInfo = {
  title: '投稿与合作',
  description: '如果你有好片推荐、资源分享或合作意向，欢迎通过以下方式联系我们。樱花TV始终欢迎热爱影视的朋友加入，共同打造更丰富的观影平台。',
  email: 'contact@sakuratv.com',
  wechat: 'SakuraTV_Official',
};

export const rankings = [
  { rank: 1, title: '归来之人', score: '9.1', views: '128万', genre: '悬疑 / 剧情', badge: '1' },
  { rank: 2, title: '暗夜追踪', score: '8.9', views: '96万', genre: '动作 / 犯罪', badge: '2' },
  { rank: 3, title: '时光之城', score: '8.7', views: '215万', genre: '爱情 / 都市', badge: '3' },
  { rank: 4, title: '星际穿越', score: '9.4', views: '89万', genre: '科幻 / 冒险', badge: '4' },
  { rank: 5, title: '深海迷踪', score: '8.5', views: '67万', genre: '惊悚 / 灾难', badge: '5' },
];

export const features = [
  { icon: 'ri-4k-line', title: '真4K超清画质', desc: '支持4K HDR与杜比全景声，每一帧都纤毫毕现，给你影院级的视觉盛宴' },
  { icon: 'ri-speed-up-line', title: '流畅不缓冲', desc: '全球CDN加速节点覆盖，智能码率自适应，晚高峰也能秒开秒播不卡顿' },
  { icon: 'ri-film-line', title: '海量片库', desc: '超过五万部电影电视剧，涵盖全球热门内容，每日持续更新最新影视资源' },
  { icon: 'ri-device-line', title: '全设备适配', desc: '手机、平板、电脑、智能电视全平台无缝切换，随时随地想看就看' },
  { icon: 'ri-shield-check-line', title: '纯净无广告', desc: '观影过程零打扰，没有弹窗、没有贴片，专注内容本身的纯粹体验' },
];

export const carouselItems = [
  {
    title: '燃夏动作大片专题',
    desc: '精选50部高分动作电影，从港式功夫到好莱坞巨制，肾上腺素飙升的视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20movie%20themed%20visual%20with%20warm%20golden%20explosive%20lighting%2C%20silhouetted%20figures%20in%20motion%2C%20dramatic%20cinematic%20smoke%20and%20sparks%2C%20dark%20background%20with%20warm%20orange%20and%20red%20accents%2C%20movie%20poster%20aesthetic%2C%20high%20contrast%2C%20epic%20film%20atmosphere&width=800&height=450&seq=sakura-carousel-01&orientation=landscape',
    tag: '热门专题',
  },
  {
    title: '日漫经典全收录',
    desc: '从《鬼灭之刃》到《进击的巨人》，最全日漫片库，日语原声+中文字幕',
    image: 'https://readdy.ai/api/search-image?query=Anime%20themed%20artistic%20visual%20with%20vibrant%20warm%20pink%20cherry%20blossom%20elements%2C%20illustrated%20character%20silhouettes%2C%20soft%20dreamy%20lighting%20with%20golden%20and%20pink%20tones%2C%20Japanese%20animation%20aesthetic%2C%20beautiful%20composition%20with%20floating%20particles%2C%20cinematic%20anime%20style&width=800&height=450&seq=sakura-carousel-02&orientation=landscape',
    tag: '动漫专区',
  },
  {
    title: '豆瓣高分TOP100',
    desc: '收录豆瓣8.5分以上口碑神作，从《肖申克的救赎》到《千与千寻》，经典永不过时',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20visual%20of%20classic%20film%20awards%20theme%2C%20warm%20golden%20spotlight%20on%20a%20vintage%20film%20reel%2C%20soft%20dark%20theater%20background%20with%20subtle%20cherry%20blossom%20petals%2C%20prestigious%20film%20festival%20atmosphere%2C%20rich%20warm%20amber%20and%20crimson%20tones%2C%20artistic%20movie%20poster%20aesthetic&width=800&height=450&seq=sakura-carousel-03&orientation=landscape',
    tag: '口碑精选',
  },
  {
    title: '暑期追剧不剧荒',
    desc: '热门国产剧、韩剧、美剧持续更新，日更200+集，这个夏天追剧追到停不下来',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20summer%20evening%20home%20theater%20scene%20with%20warm%20ambient%20lighting%2C%20a%20large%20screen%20glowing%20softly%2C%20comfortable%20living%20room%20aesthetic%2C%20golden%20hour%20light%20through%20windows%2C%20relaxed%20binge-watching%20atmosphere%2C%20cinematic%20warm%20tones%2C%20lifestyle%20photography&width=800&height=450&seq=sakura-carousel-04&orientation=landscape',
    tag: '追剧指南',
  },
  {
    title: '4K纪录片盛宴',
    desc: 'BBC、国家地理等顶级纪录片4K修复版，从自然奇观到人文历史，打开新世界的大门',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20visual%20with%20dramatic%20landscape%2C%20warm%20golden%20sunset%20over%20mountains%2C%20rich%20earth%20tones%20with%20deep%20warm%20amber%20light%2C%20cinematic%20aerial%20perspective%2C%20majestic%20natural%20scenery%2C%204K%20high%20detail%20aesthetic%2C%20National%20Geographic%20style%20photography&width=800&height=450&seq=sakura-carousel-05&orientation=landscape',
    tag: '纪录片',
  },
];

export const aboutInfo = {
  title: '关于樱花TV',
  paragraphs: [
    '樱花TV诞生于对高品质观影体验的执着追求。我们深知，真正的影迷值得拥有不妥协的画质与流畅的播放体验。自上线以来，樱花TV始终坚持以用户观影体验为核心，不断优化技术架构，拓展内容片库，致力于成为华语地区最值得信赖的免费高清影视平台。',
    '我们的片库涵盖全球范围内的电影、电视剧、动漫、纪录片与综艺节目，从好莱坞大片到独立佳作，从热门新剧到经典老片，每一部作品都经过精心筛选与画质优化。技术层面，我们采用H.265高效编码与全球CDN分发网络，确保无论用户身处何地，都能享受到低延迟、高画质的观影体验。',
  ],
};

export const faqs = [
  { q: '樱花TV真的完全免费吗？需要注册会员吗？', a: '是的，樱花TV对所有用户完全免费开放，无需注册、无需登录即可直接观看。我们通过技术优化降低运营成本，让每一位影迷都能无门槛享受高清影视。部分4K片源可能需要简单验证，但同样不收取任何费用。' },
  { q: '观看时为什么会偶尔缓冲？如何解决？', a: '樱花TV采用智能码率自适应技术，正常情况下播放非常流畅。如果遇到缓冲，建议检查当前网络环境或尝试切换清晰度档位。您也可以在播放器设置中选择合适的CDN节点，获得更佳的速度体验。' },
  { q: '支持哪些设备观看？可以在电视上播放吗？', a: '樱花TV全面支持手机、平板、电脑和智能电视等主流设备。您可以直接在电视浏览器中打开我们的网站，或使用投屏功能将内容投射到大屏幕上。1080P及以上画质在大屏设备上表现尤为出色，推荐搭配投影仪或大尺寸电视使用。' },
  { q: '片库多久更新一次？能看到最新上映的电影吗？', a: '我们的片库保持每日更新，平均每天新增200部以上的影视内容。热门新剧通常在播出后24小时内即可上线高清版本。最新院线电影由于版权窗口期，一般在下映后1-3个月内陆续收录。您可以关注更新动态模块，第一时间了解最新上架内容。' },
];

export const cards = [
  {
    title: '《暗夜追踪》第二季',
    desc: '高智商犯罪与正义的终极对决，全程高能反转不断',
    image: 'https://readdy.ai/api/search-image?query=Dark%20noir%20crime%20thriller%20visual%20with%20warm%20amber%20streetlights%20on%20wet%20pavement%2C%20mysterious%20silhouetted%20figure%2C%20cinematic%20noir%20atmosphere%2C%20deep%20shadows%20with%20golden%20highlights%2C%20film%20noir%20aesthetic%2C%20dramatic%20lighting%2C%20movie%20poster%20style&width=600&height=380&seq=sakura-card-01&orientation=landscape',
    rating: '8.9',
    tag: '热播中',
  },
  {
    title: '《时光之城》全集',
    desc: '跨越时空的感人爱情故事，年度催泪神作完结篇',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20cinematic%20scene%20with%20warm%20golden%20sunset%20light%2C%20couple%20silhouette%20against%20a%20beautiful%20cityscape%2C%20soft%20dreamy%20bokeh%20effect%2C%20emotional%20atmosphere%2C%20cherry%20blossom%20petals%20floating%2C%20Korean%20drama%20aesthetic%2C%20warm%20pink%20and%20golden%20tones&width=600&height=380&seq=sakura-card-02&orientation=landscape',
    rating: '8.7',
    tag: '已完结',
  },
  {
    title: '《星际穿越》加长版',
    desc: '诺兰科幻神作导演剪辑版，新增30分钟震撼内容',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20visual%20with%20a%20massive%20wormhole%20glowing%20warm%20golden%20light%2C%20distant%20stars%20and%20galaxies%2C%20dramatic%20cosmic%20scale%2C%20deep%20space%20with%20warm%20amber%20accents%2C%20cinematic%20science%20fiction%20aesthetic%2C%20awe-inspiring%20composition&width=600&height=380&seq=sakura-card-03&orientation=landscape',
    rating: '9.4',
    tag: '经典',
  },
  {
    title: '《深海迷踪》',
    desc: '深海之下隐藏的惊天秘密，沉浸式惊悚体验',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20scene%20with%20dark%20blue%20water%20and%20warm%20bioluminescent%20glow%2C%20eerie%20underwater%20atmosphere%2C%20shafts%20of%20golden%20light%20penetrating%20from%20above%2C%20thriller%20movie%20aesthetic%2C%20cinematic%20underwater%20photography%2C%20dramatic%20contrast&width=600&height=380&seq=sakura-card-04&orientation=landscape',
    rating: '8.5',
    tag: '新上线',
  },
  {
    title: '《鬼灭之刃》全系列',
    desc: '现象级日漫神作，含无限列车剧场版全收录',
    image: 'https://readdy.ai/api/search-image?query=Anime%20demon%20slayer%20themed%20visual%20with%20warm%20fire%20and%20water%20elements%2C%20dynamic%20sword%20action%20silhouette%2C%20Japanese%20traditional%20pattern%20background%2C%20vibrant%20warm%20orange%20and%20crimson%20tones%2C%20cinematic%20anime%20art%20style%2C%20dramatic%20composition&width=600&height=380&seq=sakura-card-05&orientation=landscape',
    rating: '9.2',
    tag: '动漫',
  },
  {
    title: '《归来的女儿》',
    desc: '豆瓣9.1分悬疑神作，结局反转烧脑到最后一秒',
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20mystery%20thriller%20visual%20with%20a%20dimly%20lit%20corridor%2C%20warm%20light%20spilling%20from%20a%20half-open%20door%2C%20eerie%20shadows%2C%20cinematic%20suspense%20atmosphere%2C%20golden%20warm%20accents%20in%20darkness%2C%20film%20noir%20inspired%2C%20high%20contrast&width=600&height=380&seq=sakura-card-06&orientation=landscape',
    rating: '9.1',
    tag: '口碑',
  },
];

export const mediaItems = [
  { title: '暗夜追踪 第二季 预告', desc: '高智商对决一触即发，新角色登场', duration: '02:35', views: '56万', image: 'https://readdy.ai/api/search-image?query=Dark%20crime%20drama%20scene%20with%20warm%20street%20lights%2C%20intense%20confrontation%20silhouette%2C%20cinematic%20noir%20style%2C%20golden%20amber%20highlights%2C%20dramatic%20mood%2C%20high%20contrast%20film%20aesthetic&width=640&height=360&seq=sakura-media-01&orientation=landscape' },
  { title: '高分纪录片：蓝色星球', desc: '4K修复版，前所未有的海底世界', duration: '48:12', views: '32万', image: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20ocean%20documentary%20scene%20with%20vibrant%20coral%20reefs%2C%20schools%20of%20fish%2C%20warm%20sunlight%20rays%20piercing%20through%20water%2C%20rich%20turquoise%20and%20golden%20tones%2C%204K%20nature%20cinematography%2C%20National%20Geographic%20style&width=640&height=360&seq=sakura-media-02&orientation=landscape' },
  { title: '时光之城 幕后花絮', desc: '主演独家访谈，拍摄趣事大公开', duration: '15:20', views: '41万', image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20warm%20lighting%2C%20camera%20crew%20silhouettes%2C%20director%20chair%2C%20soft%20golden%20set%20lights%2C%20cinematic%20production%20atmosphere%2C%20film%20making%20aesthetic%2C%20warm%20amber%20tones&width=640&height=360&seq=sakura-media-03&orientation=landscape' },
  { title: '暑期档必看TOP10', desc: '这个夏天不容错过的十部电影', duration: '08:45', views: '78万', image: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20themed%20visual%2C%20warm%20golden%20popcorn%20and%20film%20reels%2C%20cozy%20home%20theater%20with%20ambient%20lighting%2C%20cinematic%20warm%20tones%2C%20relaxed%20entertainment%20aesthetic%2C%20movie%20night%20atmosphere&width=640&height=360&seq=sakura-media-04&orientation=landscape' },
  { title: '鬼灭之刃 经典战役合集', desc: '炭治郎VS下弦之五，全程高燃', duration: '22:10', views: '92万', image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20dramatic%20fire%20and%20water%20effects%2C%20dynamic%20sword%20clash%20silhouettes%2C%20Japanese%20aesthetic%20background%2C%20warm%20orange%20and%20red%20energy%20bursts%2C%20cinematic%20anime%20art%2C%20intense%20action%20composition&width=640&height=360&seq=sakura-media-05&orientation=landscape' },
];

export const appInfo = {
  title: '随时随地，高清随行',
  desc: '樱花TV全面适配移动端浏览器，无需下载APP即可畅享高清影视。添加到手机桌面，一键直达你的私人影院。支持Chromecast和AirPlay投屏，大屏观影更震撼。',
  features: ['移动端完美适配', '一键添加至桌面', '支持投屏播放', '流量优化模式', '夜间观影模式'],
};

export const indexItems = [
  { title: '动作电影', count: '8,200+', icon: 'ri-sword-line', desc: '高燃打斗、枪战追逐、极限特技' },
  { title: '喜剧片', count: '5,600+', icon: 'ri-emotion-laugh-line', desc: '爆笑解压、温情幽默、合家欢' },
  { title: '爱情剧', count: '4,300+', icon: 'ri-heart-line', desc: '甜宠虐恋、都市情感、青春校园' },
  { title: '悬疑推理', count: '3,900+', icon: 'ri-search-eye-line', desc: '烧脑反转、侦探破案、心理惊悚' },
  { title: '科幻奇幻', count: '2,800+', icon: 'ri-rocket-line', desc: '未来世界、异星冒险、魔法大陆' },
  { title: '动画动漫', count: '6,500+', icon: 'ri-ghost-line', desc: '日漫国漫、剧场版、经典番剧' },
  { title: '纪录片', count: '3,200+', icon: 'ri-earth-line', desc: '自然人文、历史探索、科学解密' },
  { title: '恐怖惊悚', count: '2,100+', icon: 'ri-moon-line', desc: '灵异鬼怪、心理恐惧、末日生存' },
];